/**
 * Test a File against an HTML `accept` string — the same value passed to the
 * native `<input accept>` and antd's `<Upload accept>`. Tokens may be:
 *   - an extension:    ".pdf"
 *   - a wildcard MIME: "image/*"
 *   - an exact MIME:   "image/png"
 * Returns true if the file matches any token. An empty/undefined `accept` means
 * "accept anything". Extension matching covers browsers that report an empty
 * `file.type` for some office/video formats.
 */
export function isFileAccepted(file: File, accept?: string): boolean {
  if (!accept) return true;
  const tokens = accept
    .split(',')
    .map((t) => t.trim().toLowerCase())
    .filter(Boolean);
  // all tokens were whitespace — treat as "accept all"
  if (tokens.length === 0) return true;

  const name = file.name.toLowerCase();
  const type = file.type.toLowerCase();

  return tokens.some((token) => {
    if (token.startsWith('.')) return name.endsWith(token);
    if (token.endsWith('/*')) return type.startsWith(token.slice(0, -1));
    return type === token;
  });
}
